module.exports = __webpack_public_path__ + "static/media/599905_431894116879782_271699917_n.07ca2720.jpg";